export type Predicate = (props: Record<string, unknown>) => boolean;
